import {
	mixpanelAlias,
	mixpanelIdentify,
	mixpanelSetPeople,
} from "@helpers/mixpanel.helper";
import type { createClient } from "@services/sdk";
import { Actioner, BuyFlowActionKeys } from "@services/actioner";

export const getAwsId = async (
	clientRef: ReturnType<typeof createClient>,
	email: string,
) => {
	const awsIdLookUpResult = await clientRef.awsIdLookUp(email);

	if (!awsIdLookUpResult.isOk()) {
		return;
	}

	awsIdLookUpResult.when({
		success: (awsId) => {
			Actioner.trigger(BuyFlowActionKeys.BUY_SET_BRAZE_ID, {
				externalId: awsId,
			});
			// now we let mixpanel know the awsID
			mixpanelAlias(awsId);
			mixpanelIdentify(awsId);
			mixpanelSetPeople(awsId);
			return awsId;
		},
		failure: () => {},
	});
};
